import { useDeepEffect } from '@crossnokaye/ux-common';

import { useSettingsSubscription } from '@/hooks/query-hooks/gaia-api/use-settings-subscription';
import { SubscriptionIdentifier } from '@/hooks/query-hooks/gaia-api/use-subscription-base';
import { useCurrentFacility } from '@/hooks/use-current-facility';

/**
 * Hook for subscribing to settings data for equipment details.
 *
 * Automatically extracts setting references from equipment response data and subscribes
 * to them for real-time updates. Handles both display settings and component settings
 * used in action component states.
 *
 * @param equipmentResponse - The equipment details response containing setting references
 */
export const useSubscribeEBSettings = (settingsIdentifiers: SubscriptionIdentifier[]) => {
  const { agentId } = useCurrentFacility();

  const { subscribe: subscribeSettings } = useSettingsSubscription({ agentId });

  useDeepEffect(() => {
    if (settingsIdentifiers?.length) {
      subscribeSettings(settingsIdentifiers);
    }
  }, [subscribeSettings, settingsIdentifiers]);
};
